import { LearnerTrainingStatus } from '~/data';
import { Pretest } from '../pretest/PretestSlice';

interface NavigationItem {
  id: string;
  title: string;
  position: number;
  duration: number;
}

export interface Sequence extends NavigationItem {
  kind: 'sequence';
  type: string;
  chapterId: string;
  chapterSequenceId: string;
  icon?: string;
  sendRxdInteractions?: boolean;
}

export interface Chapter extends NavigationItem {
  kind: 'chapter';
  sequenceCount: number;
  icon?: string;
  // True when the learner tested out of the chapter in the pretest. Its slides
  // stay open for review but are not part of the learner's path.
  testedOut?: boolean;
}

export interface Policy {
  id: string;
  name?: string;
  policyUrl?: string;
}

export interface CompanyContact {
  name?: string;
  department?: string;
  email?: string;
  phone?: string;
  otherInfo?: string;
}

export interface NavigationSlice {
  open: boolean;
  learnerTrainingId: string;
  chapterSequenceId: string;
  title: string;
  duration: number;
  regionName?: string;
  activeItemPosition: number;
  highestUnlockedPosition: number;
  items: Array<Sequence | Chapter>;
  status: LearnerTrainingStatus;
  activateSequence(id: string): void;
  unlockSequence(id: string): void;
  next(): Promise<string>;
  prev(): Promise<string>;
  toggleNav(open?: boolean): void;
  skip?: boolean;
  player?: string;
  scorePercent: number;
  lastAttemptScorePercent?: number | null;
  scorePassingPercent?: number;
  attemptStatus?: string;
  // Both null unless the company caps attempts (behind the attempt_limits flag).
  attemptLimit?: number | null;
  attemptsRemaining?: number | null;
  // Null unless the company has the course_pretests flag and a pretest applies
  // to the current attempt.
  pretest: Pretest | null;
  policy?: Policy;
  policies?: Array<Policy>;
  policiesForSignature?: Array<Policy>;
  policyAcknowledgement: boolean;
  policyAcknowledgementSignature: boolean;
  certificateUrl?: string;
  featureShowCertificate?: boolean;
  featureShowSocialShare?: boolean;
  featureShowHomeButton?: boolean;
  showDemoBanner?: boolean;
  shouldSaveVideoWatchedSeconds?: boolean;
  autoSaveVideoWatchedSecondsIntervalInSeconds?: number | null;
  companyContacts?: Array<CompanyContact>;
  shouldDisplayTimerStillRunningModal?: boolean;
  remainingDurationInMinutesForCourseTimers?: number | null;
  remainingDurationInSecondsForCourseTimers?: number | null;
  reviewTimerPaused?: boolean;
  hideTimerStillRunningModal(): void;
  getFirstChapterFirstSequenceId(): string | null;
}
